export default __webpack_public_path__ + "static/media/kitchen5-afterE-768w.38389ef2.avif";